import React from 'react';

import { Tabs } from 'antd';
import styled from 'styled-components';

import Button from 'components/lib/Button';
import Modal from 'components/lib/Modal';

const DetailsPreview = styled.pre`
  width: 100%;
  max-width: 100%;
  max-height: 65vh;
  margin: 24px 0px;
  padding: 16px;
  box-sizing: border-box;
  overflow: auto;
  scrollbar-gutter: stable;
  border: 1px solid var(--line-gray);
  border-radius: 4px;
  background: var(--background-gray);
  color: var(--text-primary);
  font-size: 12px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

export type RecommendationEvidenceDetailsTabType = {
  key: string;
  label: string;
  value: Record<string, unknown>;
};

export type RecommendationEvidenceDetailsPreviewType = {
  title: string;
  tabs: RecommendationEvidenceDetailsTabType[];
};

type Props = {
  preview: RecommendationEvidenceDetailsPreviewType | null;
  onClose: () => void;
};

const RecommendationEvidenceDetailsModal = ({ preview, onClose }: Props) => (
  <Modal
    open={Boolean(preview)}
    title={preview?.title || 'Evidence details'}
    footer={
      <Button data-test-id="aici-website-evidence-details-close" onClick={onClose}>
        Close
      </Button>
    }
    width="70%"
    onCancel={onClose}
    data-test-id="aici-website-evidence-details-modal"
  >
    <Tabs
      items={(preview?.tabs || []).map((tab) => ({
        key: tab.key,
        label: <span data-test-id={`aici-website-evidence-details-tab-${tab.key}`}>{tab.label}</span>,
        children: <DetailsPreview className="mini-scroll">{JSON.stringify(tab.value, null, 2)}</DetailsPreview>,
      }))}
    />
  </Modal>
);

export default RecommendationEvidenceDetailsModal;
